import type { ReactElement } from "react";
import { MenuBottomBar } from "./MenuBottomBar";
import { MenuBottomBarOffline } from "./MenuBottomBarOffline";
import { useOnlineStatusContext } from "@/context/OnlineStatusContext";

export const AppFooter = (): ReactElement => {
	const { isOnline } = useOnlineStatusContext();

	return (
		<footer className="sticky bottom-0 items-center h-[88px] w-full pb-safe-offset-4 pt-2 bg-background z-20 md:px-safe-offset-6">
			{isOnline ? <MenuBottomBar /> : <MenuBottomBarOffline />}
		</footer>
	);
};